import React from 'react';

import MoveBack from '~/assets/icons/gnb/ic_back_24x24.svg';

type Props = {
  title?: string | React.ReactNode;
  right?: React.ReactNode;
  onLeftClick?: () => void;
};

const AppBar = ({ title, right, onLeftClick }: Props) => {
  return (
    <nav className="sticky top-0 z-20 flex h-[60px] items-center justify-between bg-screen-01 px-16 text-normal">
      <div className="mr-12 flex flex-1 items-center">
        {onLeftClick && (
          <button
            type="button"
            className="size-24 after-back-button after:content-['']"
            onClick={onLeftClick}
          >
            <MoveBack className="w-24 fill-current" />
          </button>
        )}
      </div>
      <div className="max-w-[256px] truncate text-center typo-title100-semibold">
        {title}
      </div>
      <div className="ml-12 flex flex-1 justify-end">{right}</div>
    </nav>
  );
};

export default AppBar;
